import rdf from '@zazuko/env/web.js';
import ModelFactory from '../model/ModelFactory.js';
import { flatten, union } from './shapePatterns.js';
import { createVariableSequence } from './variableSequence.js';
export function shapeToPatterns(shape, options = {}) {
    const factory = new ModelFactory(options);
    const nodeShape = factory.nodeShape(shape);
    const variable = createVariableSequence(options.objectVariablePrefix || 'resource');
    const focusNode = options.focusNode || variable();
    const { patterns, constraints } = buildNodeShape({ nodeShape, variable, focusNode });
    if (patterns.childPatterns && patterns.childPatterns.length) {
        const subQueries = flattenChildPatterns(patterns);
        return union(toSubquery()(patterns), ...[...subQueries].map(toSubquery(constraints.whereClause)));
    }
    return patterns;
}
function* flattenChildPatterns(patterns) {
    for (const child of patterns.childPatterns) {
        yield child;
        if (child.childPatterns && child.childPatterns.length) {
            yield* flattenChildPatterns(child);
        }
    }
}
function toSubquery(constraints = []) {
    return (patterns) => {
        const variables = rdf.termSet(patterns.constructClause
            .flatMap(quad => [quad.subject, quad.predicate, quad.object])
            .filter((term) => term.termType === 'Variable'));
        return {
            constructClause: patterns.constructClause,
            whereClause: [{
                    type: 'group',
                    patterns: [{
                            type: 'query',
                            queryType: 'SELECT',
                            prefixes: {},
                            variables: [...variables],
                            where: [
                                ...patterns.whereClause,
                                ...constraints,
                            ],
                        }],
                }],
        };
    };
}
function buildNodeShape({ nodeShape, variable, focusNode }) {
    const properties = nodeShape.buildPatterns({
        focusNode,
        variable,
        rootPatterns: [],
    });
    const constraints = {
        constructClause: [],
        whereClause: nodeShape.buildConstraints({
            focusNode,
            valueNode: variable(),
            variable,
            rootPatterns: [],
        }),
    };
    return {
        patterns: flatten(properties, constraints),
        constraints,
    };
}
